import { render, staticRenderFns } from "./MovieDetail.vue?vue&type=template&id=4c6eb272&"
import script from "./MovieDetail.vue?vue&type=script&lang=js&"
export * from "./MovieDetail.vue?vue&type=script&lang=js&"
import style0 from "./MovieDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports